import type { Diagram, Project } from '../../store/types.ts';

type HeaderProps = {
  project: Project | undefined;
  diagram: Diagram | undefined;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  onOpenSettings: () => void;
  onRenameDiagram: () => void;
  onOpenSidebar: () => void;
};

function MenuIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function LogoIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M4 4h8a8 8 0 0 1 0 16H4V4Z" stroke="currentColor" strokeWidth="2" fill="none" />
      <path d="M10 9l4 3-4 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function GearIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 1v2M8 13v2M1 8h2M13 8h2M2.93 2.93l1.41 1.41M11.66 11.66l1.41 1.41M2.93 13.07l1.41-1.41M11.66 4.34l1.41-1.41" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function Header({ project, diagram, sidebarOpen, onToggleSidebar, onOpenSettings, onRenameDiagram, onOpenSidebar }: HeaderProps) {
  return (
    <header className="ds-header">
      <div className="ds-header__left">
        <button
          type="button"
          className="ds-header__menu-btn"
          onClick={onToggleSidebar}
          aria-label={sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
        >
          <MenuIcon />
        </button>
        <div className="ds-header__brand">
          <LogoIcon />
          <span>Delegate Studio</span>
        </div>
      </div>

      <nav className="ds-breadcrumb" aria-label="Breadcrumb">
        <button
          type="button"
          className="ds-breadcrumb__segment"
          onClick={onOpenSidebar}
          title="Switch project"
        >
          {project?.name || 'Project'}
        </button>
        <span className="ds-breadcrumb__sep" aria-hidden="true">/</span>
        <button
          type="button"
          className="ds-breadcrumb__segment ds-breadcrumb__segment--active"
          onClick={onRenameDiagram}
          title="Click to rename"
        >
          {diagram?.title || 'Untitled Diagram'}
        </button>
      </nav>

      <div className="ds-header__right">
        <button type="button" className="ds-icon-btn" onClick={onOpenSettings} aria-label="Settings">
          <GearIcon />
        </button>
      </div>
    </header>
  );
}
